@if (isDev) {
  <button
    type="button"
    class="fixed bottom-2 left-2 z-[100000] rounded bg-black px-3 py-2 text-sm text-green-400"
    (click)="toggle()"
  >
    {{ show() ? 'Hide' : 'Show' }} Debug Logger
  </button>

  @if (show()) {
    <div
      class="fixed inset-x-0 bottom-12 z-[99999] flex h-60 flex-col bg-black text-green-400"
    >
      <div class="flex gap-2 border-b border-green-800 p-2">
        <button type="button" (click)="copy()">Copy</button>
        <button type="button" (click)="clear()">Clear</button>
      </div>

      <pre class="flex-1 overflow-auto whitespace-pre-wrap break-words p-2">{{ text() }}</pre>
    </div>
  }
}